import AppBanner from "components/Sections/AppsSection/AppBanner"
import dynamic from "next/dynamic"
import Image from "next/image"
import { useEffect } from "react"

const Footer = dynamic(() => import("components/Layout/Footer/Footer"), {
    ssr: false,
    loading: () => {
        return (
            <footer
                className={`fixed bottom-0 hidden h-[325px] flex-col overflow-hidden bg-white shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87] md:flex`}
            ></footer>
        )
    },
})

interface IProps {
    title: string
    desc: string
    imageURL: string
    backgroundColor: string
}

const AboutSection = ({ title, desc, imageURL, backgroundColor }: IProps) => {
    return (
        <div
            style={{ backgroundColor: backgroundColor }}
            className={`parallax-slide h-screen`}
        >
            <div className="layout grid h-full grid-cols-2">
                <div className="flex h-full flex-col justify-center gap-8">
                    <p className="font-bold text-white lg:text-6xl">{title}</p>
                    <p
                        style={{ lineHeight: "50px" }}
                        className="text-white lg:text-4xl"
                    >
                        {desc}
                    </p>
                </div>
                <div className="flex h-full items-center justify-center">
                    <div className="flex items-center justify-center">
                        <Image
                            src={imageURL}
                            alt="celebration"
                            width={400}
                            height={400}
                            // layout="responsive"
                            className="tilt-image rounded-md bg-cover bg-center shadow-2xl lg:h-full"
                            quality="100"
                            style={{
                                boxShadow:
                                    "50px 50px 100px rgba(0, 0, 0, 0.2), -30px -30px 50px rgba(0, 0, 0, 0.2)",
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const AboutUsPageComponent = () => {
    const sectionData = [
        {
            title: "رؤيتنـــا",
            desc: "رؤيـتنا تتـعـدى جبـالنا وتـغوص في أعـمـاق بـحارنا وتـداعـب غـيـوم سـمـاءنا. نـهدف إلى تـوفير منصة سهلة استخدام وسلسة التفاعل تعزز التجربة الترفيهية.",
            imageURL:
                "https://cdn.pass-tickets.com/frontend/Frame%201000003592.png",
            backgroundColor: "#FAA224",
        },
        {
            title: "قيمنـــا",
            desc: "قيمنـا هـي الـبهجـة، و الـمرح والشغف، والتنوع، والابتكار، والثقة.",
            imageURL:
                "https://cdn.pass-tickets.com/frontend/Frame%201000003593.png",
            backgroundColor: "#10B89F",
        },
        {
            title: "مهمتنـــا",
            desc: "وعندنا مهمه اسمى وهي صنع السعادة، ونحقق ذلك من خلال توفير خيارات ترفيهية مـتنوعة تنـاسب الـكبار والـصغار وتـساهم في رفـع جـودة الـحياة.",
            imageURL:
                "https://cdn.pass-tickets.com/frontend/Frame%201000003592%20(1).png",
            backgroundColor: "#393085",
        },
        {
            title: "غايتنـــــا",
            desc: "غايتنـا هـي صنع تجارب ترفيهية لا حصر لها من حيث النوع والعدد، وإعادة تعريف الترفيه في مملكتنا، وخلق عالـم مذهل من البهجة و السعادة من خـلال منصة رقمية متكاملة.",
            imageURL:
                "https://cdn.pass-tickets.com/frontend/Frame%201000003595.png",
            backgroundColor: "#ED1A5A",
        },
    ]

    const tiltImage = () => {
        const tiltEls = document.querySelectorAll(".tilt-image")

        const tiltMove = (x, y) =>
            `perspective(500px) rotateX(${x}deg) rotateY(${y}deg)`

        tiltEls.forEach((tilt: any) => {
            const height = tilt.clientHeight
            const width = tilt.clientWidth

            tilt.addEventListener("mousemove", (e: any) => {
                const x = e.layerX
                const y = e.layerY
                const multiplier = 7

                const xRotate = multiplier * ((x - width / 2) / width)
                const yRotate = -multiplier * ((y - height / 2) / height)

                tilt.style.transform = tiltMove(xRotate, yRotate)
            })

            tilt.addEventListener("mouseout", (e: any) => {
                tilt.style.transform = tiltMove(0, 0)
            })
        })
    }

    useEffect(() => {
        tiltImage()
    }, [])

    return (
        <>
            <div className="parallax-container">
                <div className="parallax-slide h-screen">
                    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden">
                        <Image
                            src="https://cdn.pass-tickets.com/frontend/Desktop - 9 (2).png"
                            width={0}
                            height={0}
                            alt="hero image"
                            layout="responsive"
                            className="h-screen bg-cover bg-center lg:h-full"
                            quality="100"
                        />
                    </div>
                </div>
                <div className="parallax-slide h-screen">
                    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden">
                        <Image
                            src="https://cdn.pass-tickets.com/frontend/Desktop - 13 (1).png"
                            width={0}
                            height={0}
                            alt="hero image"
                            layout="responsive"
                            className="h-screen bg-cover bg-center lg:h-full"
                            quality="100"
                        />
                    </div>
                </div>
                {sectionData.map(
                    (
                        { title, desc, imageURL, backgroundColor },
                        index: number
                    ) => (
                        <AboutSection
                            key={index}
                            title={title}
                            desc={desc}
                            imageURL={imageURL}
                            backgroundColor={backgroundColor}
                        />
                    )
                )}
                {/* <CompanyValues /> */}
                <div className="parallax-slide hidden h-screen lg:block">
                    <div className="flex h-full flex-col items-center justify-center">
                        <AppBanner />
                    </div>
                </div>

                <div className="parallax-slide">
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default AboutUsPageComponent
